export const TIER_1_CITIES = [
  {
    slug: "mumbai",
    name: "Mumbai",
    state: "Maharashtra",
    pins: "400001-400104",
    pop: "2.1 Cr",
    providers: "15,000+",
    tagline: "Maximum City, Maximum Choices",
    desc: "Mumbai, the financial capital of India, is where HumanOnRent.AI thrives the most. From the corporate towers of BKC to the vibrant streets of Bandra, from the heritage lanes of South Mumbai to the suburbs of Borivali — find verified professionals for every occasion.",
    areas: ["Bandra", "Andheri", "South Mumbai", "Powai", "Juhu", "Worli", "Thane", "Navi Mumbai", "Borivali", "Malad"],
    topServices: ["Business Events", "Travel", "Shopping", "Dinner", "Elder Care"],
    seoContent: "Looking for human on rent in Mumbai? HumanOnRent.AI offers 15,000+ verified providers across all Mumbai pin codes (400001-400104). Whether you need a travel buddy for Gateway of India, a shopping partner for Linking Road, or elder care in Powai — our AI matches you instantly. Available 24/7 across Bandra, Andheri, Juhu, Worli, Thane, Navi Mumbai, and every corner of Maximum City."
  },
  {
    slug: "delhi",
    name: "Delhi",
    state: "Delhi NCR",
    pins: "110001-110096",
    pop: "1.9 Cr",
    providers: "14,000+",
    tagline: "Capital of India, Capital of Opportunities",
    desc: "Delhi NCR is our second-largest market. From the political corridors of Lutyens Delhi to the tech hubs of Noida and Gurgaon, we cover the entire National Capital Region with verified, professional humans for rent.",
    areas: ["South Delhi", "Noida", "Gurgaon", "Dwarka", "Connaught Place", "Rohini", "Karol Bagh", "Greater Noida", "Faridabad", "Ghaziabad"],
    topServices: ["Business Events", "Travel", "Medical Help", "Shopping", "Parties"],
    seoContent: "Find human on rent in Delhi NCR. HumanOnRent.AI has 14,000+ verified providers across Delhi (110001-110096), Noida, Gurgaon, and the entire NCR. Need a business event partner in CP, a travel buddy for Agra trips, or medical help support in South Delhi? Our AI-powered platform connects you instantly."
  },
  {
    slug: "bangalore",
    name: "Bangalore",
    state: "Karnataka",
    pins: "560001-560100",
    pop: "1.2 Cr",
    providers: "12,000+",
    tagline: "Silicon Valley of India Meets AI Matching",
    desc: "Bangalore's tech-savvy population makes it perfect for HumanOnRent.AI. Our providers here are young, professional, and tech-forward. From Koramangala to Whitefield, Indiranagar to Electronic City — find your perfect match.",
    areas: ["Koramangala", "Indiranagar", "Whitefield", "HSR Layout", "Electronic City", "JP Nagar", "MG Road", "Jayanagar", "Marathahalli", "Hebbal"],
    topServices: ["Hanging Out", "Clubbing", "Sporting Events", "Business Events", "Travel"],
    seoContent: "Human on rent in Bangalore — 12,000+ verified providers across all Bangalore pin codes (560001-560100). From weekend hangouts in Koramangala to corporate events in Whitefield, our AI-driven platform connects Bangaloreans with the perfect match. Available across Indiranagar, HSR, Electronic City, and all areas."
  },
  {
    slug: "hyderabad",
    name: "Hyderabad",
    state: "Telangana",
    pins: "500001-500100",
    pop: "1.0 Cr",
    providers: "8,000+",
    tagline: "City of Pearls, City of Connections",
    desc: "Hyderabad's unique blend of old-world charm and tech innovation makes it a perfect market. From Hitech City's corporate events to Old City's cultural tours, HumanOnRent.AI covers every need.",
    areas: ["Hitech City", "Gachibowli", "Banjara Hills", "Jubilee Hills", "Secunderabad", "Kukatpally", "Madhapur", "Ameerpet", "Begumpet", "LB Nagar"],
    topServices: ["Culture", "Business Events", "Travel", "Dinner", "Shopping"],
    seoContent: "Rent a human in Hyderabad — 8,000+ verified providers across Hyderabad pin codes (500001-500100). Cultural tours in Old City, business partners in Hitech City, dinner partners in Banjara Hills. Our AI matches you with providers across Gachibowli, Jubilee Hills, Secunderabad, and all of Hyderabad."
  },
  {
    slug: "chennai",
    name: "Chennai",
    state: "Tamil Nadu",
    pins: "600001-600130",
    pop: "87 Lac",
    providers: "7,500+",
    tagline: "Gateway to South India's Best Services",
    desc: "Chennai, the cultural capital of South India, has a growing network of verified providers. From Marina Beach outings to temple visits, IT corridor events to hospital accompaniment — Chennai providers deliver with warmth.",
    areas: ["T. Nagar", "Anna Nagar", "Adyar", "Velachery", "OMR", "ECR", "Mylapore", "Nungambakkam", "Porur", "Tambaram"],
    topServices: ["Medical Help", "Elder Care", "Culture", "Travel", "Tutoring"],
    seoContent: "Human on rent in Chennai — 7,500+ verified providers across Chennai pin codes (600001-600130). Medical help support at Apollo, elder care in Adyar, cultural tours in Mylapore, travel partners for Mahabalipuram. AI-powered matching across T. Nagar, Anna Nagar, OMR, ECR, and all of Chennai."
  },
  {
    slug: "kolkata",
    name: "Kolkata",
    state: "West Bengal",
    pins: "700001-700157",
    pop: "1.5 Cr",
    providers: "6,000+",
    tagline: "City of Joy, City of Warm Connections",
    desc: "Kolkata brings warmth and culture to every interaction. Our providers here excel at cultural events, pujas, weddings, and the city's famous adda culture. From Park Street to Salt Lake, we've got you covered.",
    areas: ["Park Street", "Salt Lake", "New Town", "Ballygunge", "Howrah", "Dum Dum", "Gariahat", "Alipore", "Behala", "Tollygunge"],
    topServices: ["Culture", "Parties", "Elder Care", "Shopping", "Music"],
    seoContent: "Rent a human in Kolkata — 6,000+ verified providers across Kolkata pin codes (700001-700157). Durga Puja partners, wedding event support, cultural tours, and warm connections. Available across Park Street, Salt Lake, New Town, Howrah, and every corner of the City of Joy."
  },
  {
    slug: "pune",
    name: "Pune",
    state: "Maharashtra",
    pins: "411001-412308",
    pop: "72 Lac",
    providers: "9,000+",
    tagline: "Oxford of the East, Vibrant & Young",
    desc: "Pune's young, educated population makes it one of our most active cities. College areas, IT parks, and the city's vibrant food and nightlife scene keep our providers busy around the clock.",
    areas: ["Koregaon Park", "Hinjawadi", "Kharadi", "Viman Nagar", "Baner", "Aundh", "Shivaji Nagar", "Wakad", "Hadapsar", "PCMC"],
    topServices: ["Hanging Out", "Clubbing", "Travel", "Sporting Events", "Dinner"],
    seoContent: "Human on rent in Pune — 9,000+ verified providers across Pune pin codes (411001-412308). Weekend hangouts in Koregaon Park, trekking partners for Lonavala, dinner partners in FC Road. AI-powered matching across Hinjawadi, Kharadi, Viman Nagar, Baner, and all of Pune."
  },
  {
    slug: "ahmedabad",
    name: "Ahmedabad",
    state: "Gujarat",
    pins: "380001-382481",
    pop: "63 Lac",
    providers: "5,500+",
    tagline: "Heritage City with Modern Services",
    desc: "Ahmedabad blends heritage with modernity. From Navratri celebrations to business meetings at GIFT City, our providers cater to Gujarat's unique cultural needs with professionalism and warmth.",
    areas: ["SG Highway", "Prahlad Nagar", "Vastrapur", "Navrangpura", "Maninagar", "Satellite", "Bopal", "Thaltej", "CG Road", "Ashram Road"],
    topServices: ["Culture", "Business Events", "Shopping", "Parties", "Travel"],
    seoContent: "Rent a human in Ahmedabad — 5,500+ verified providers across Ahmedabad pin codes (380001-382481). Navratri partners, business event support at GIFT City, shopping partners at Manek Chowk. Available across SG Highway, Prahlad Nagar, Vastrapur, and all of Ahmedabad."
  }
];

export const TIER_2_CITIES = [
  {
    slug: "jaipur",
    name: "Jaipur",
    state: "Rajasthan",
    pins: "302001-303905",
    providers: "4,000+",
    tagline: "Pink City's Premier Human Rental Service",
    desc: "Jaipur's royal heritage meets modern services. From palace tours to wedding events, Jaipur providers bring Rajasthani hospitality to every interaction.",
    areas: ["Malviya Nagar", "C-Scheme", "Vaishali Nagar", "Mansarovar", "Tonk Road"],
    topServices: ["Travel", "Culture", "Parties", "Shopping", "Business Events"],
    seoContent: "Human on rent in Jaipur — 4,000+ verified providers across all Jaipur pin codes. Royal tours, wedding event partners, shopping at Johari Bazaar. AI-powered matching across the Pink City."
  },
  {
    slug: "lucknow",
    name: "Lucknow",
    state: "Uttar Pradesh",
    pins: "226001-227105",
    providers: "3,500+",
    tagline: "City of Nawabs, City of Hospitality",
    desc: "Lucknow's legendary hospitality reflects in our provider network. Known for culture, cuisine, and warmth — Lucknow providers deliver the best experience.",
    areas: ["Hazratganj", "Gomti Nagar", "Aliganj", "Indira Nagar", "Mahanagar"],
    topServices: ["Culture", "Dinner", "Travel", "Shopping", "Elder Care"],
    seoContent: "Rent a human in Lucknow — 3,500+ verified providers. Cultural tours, dinner partners for Tunday Kebab outings, and warm connections across the City of Nawabs."
  },
  {
    slug: "chandigarh",
    name: "Chandigarh",
    state: "Punjab/Haryana",
    pins: "160001-160101",
    providers: "2,800+",
    tagline: "The City Beautiful, The Service Perfect",
    desc: "Chandigarh's planned city layout and vibrant lifestyle make it ideal for our services. Young, energetic providers for every occasion.",
    areas: ["Sector 17", "Sector 22", "Sector 35", "Mohali", "Panchkula"],
    topServices: ["Hanging Out", "Clubbing", "Shopping", "Travel", "Sporting Events"],
    seoContent: "Human on rent in Chandigarh — 2,800+ verified providers across Chandigarh, Mohali, and Panchkula. Weekend hangouts, clubbing partners, and more in the City Beautiful."
  },
  {
    slug: "indore",
    name: "Indore",
    state: "Madhya Pradesh",
    pins: "452001-453771",
    providers: "2,500+",
    tagline: "India's Cleanest City, India's Best Service",
    desc: "Indore is India's cleanest city and a growing hub for our services. Known for street food and warm people, our providers reflect this spirit.",
    areas: ["Vijay Nagar", "Palasia", "Rau", "Bhawarkuan", "Sapna Sangeeta"],
    topServices: ["Dinner", "Shopping", "Travel", "Hanging Out", "Culture"],
    seoContent: "Rent a human in Indore — 2,500+ verified providers. Food tour partners at Sarafa Bazaar, shopping at Palasia, and more across India's cleanest city."
  },
  {
    slug: "nagpur",
    name: "Nagpur",
    state: "Maharashtra",
    pins: "440001-441614",
    providers: "2,200+",
    tagline: "Orange City, Fresh Connections",
    desc: "Nagpur, the heart of India, connects you with verified providers for all occasions. Central location makes it a key market.",
    areas: ["Dharampeth", "Sadar", "Civil Lines", "Sitabuldi", "Wardha Road"],
    topServices: ["Travel", "Business Events", "Medical Help", "Shopping", "Dinner"],
    seoContent: "Human on rent in Nagpur — 2,200+ verified providers across all Nagpur pin codes. Business partners, travel buddies, and medical support in the Orange City."
  },
  {
    slug: "bhopal",
    name: "Bhopal",
    state: "Madhya Pradesh",
    pins: "462001-464993",
    providers: "2,000+",
    tagline: "City of Lakes, Lake of Services",
    desc: "Bhopal's scenic beauty and cultural richness attract diverse service needs. Our providers cater to tourism, events, and daily needs.",
    areas: ["New Market", "MP Nagar", "Arera Colony", "Kolar", "Hoshangabad Road"],
    topServices: ["Travel", "Culture", "Dinner", "Elder Care", "Shopping"],
    seoContent: "Rent a human in Bhopal — 2,000+ verified providers. Lake tours, cultural events, and dining partners across the City of Lakes."
  },
  {
    slug: "patna",
    name: "Patna",
    state: "Bihar",
    pins: "800001-801503",
    providers: "1,800+",
    tagline: "Ancient City, Modern Services",
    desc: "Patna's growing economy and young population drive demand for professional services. Our providers serve across the city with reliability.",
    areas: ["Boring Road", "Kankarbagh", "Bailey Road", "Patna City", "Danapur"],
    topServices: ["Medical Help", "Elder Care", "Tutoring", "Travel", "Shopping"],
    seoContent: "Human on rent in Patna — 1,800+ verified providers. Medical support, tutoring, elder care, and travel partners across Patna."
  },
  {
    slug: "vadodara",
    name: "Vadodara",
    state: "Gujarat",
    pins: "390001-391761",
    providers: "1,500+",
    tagline: "Cultural Capital of Gujarat",
    desc: "Vadodara's rich cultural heritage and growing IT sector create diverse needs. Our providers excel at cultural events and corporate functions.",
    areas: ["Alkapuri", "Sayajigunj", "Fatehgunj", "Manjalpur", "Gotri"],
    topServices: ["Culture", "Business Events", "Shopping", "Travel", "Parties"],
    seoContent: "Rent a human in Vadodara — 1,500+ verified providers. Cultural event partners, business support, and more in Gujarat's cultural capital."
  },
  {
    slug: "surat",
    name: "Surat",
    state: "Gujarat",
    pins: "394101-395010",
    providers: "3,000+",
    tagline: "Diamond City Shines with Services",
    desc: "Surat, India's diamond capital, has a dynamic business community that values professional services. Fast-growing provider network.",
    areas: ["Vesu", "Adajan", "Varachha", "Athwa", "Piplod"],
    topServices: ["Business Events", "Dinner", "Shopping", "Parties", "Travel"],
    seoContent: "Human on rent in Surat — 3,000+ verified providers. Business event partners, dinner outings, and more in India's Diamond City."
  },
  {
    slug: "visakhapatnam",
    name: "Visakhapatnam",
    state: "Andhra Pradesh",
    pins: "530001-531219",
    providers: "1,200+",
    tagline: "Jewel of the East Coast",
    desc: "Vizag's beautiful coastline and growing economy make it an emerging market. Beach outings, corporate events, and cultural tours.",
    areas: ["Beach Road", "MVP Colony", "Gajuwaka", "Madhurawada", "Seethammadhara"],
    topServices: ["Travel", "Business Events", "Dinner", "Culture", "Hanging Out"],
    seoContent: "Rent a human in Visakhapatnam — 1,200+ verified providers. Beach partners, business event support, and cultural tours in Vizag."
  },
  {
    slug: "coimbatore",
    name: "Coimbatore",
    state: "Tamil Nadu",
    pins: "641001-642154",
    providers: "1,500+",
    tagline: "Manchester of South India",
    desc: "Coimbatore's industrial prowess and temple culture create unique service demands. Our providers serve business and spiritual needs alike.",
    areas: ["RS Puram", "Gandhipuram", "Peelamedu", "Saibaba Colony", "Singanallur"],
    topServices: ["Business Events", "Culture", "Medical Help", "Travel", "Elder Care"],
    seoContent: "Human on rent in Coimbatore — 1,500+ providers. Business event support, temple tours, and medical assistance across Coimbatore."
  },
  {
    slug: "kochi",
    name: "Kochi",
    state: "Kerala",
    pins: "682001-683587",
    providers: "1,800+",
    tagline: "Queen of the Arabian Sea",
    desc: "Kochi's cosmopolitan culture and tourism industry make it a vibrant market. Backwater tours, IT events, and cultural experiences.",
    areas: ["MG Road", "Kakkanad", "Edappally", "Fort Kochi", "Vyttila"],
    topServices: ["Travel", "Culture", "Business Events", "Dinner", "Hanging Out"],
    seoContent: "Rent a human in Kochi — 1,800+ verified providers. Backwater tour partners, business support in Kakkanad, and cultural experiences in Fort Kochi."
  },
  {
    slug: "guwahati",
    name: "Guwahati",
    state: "Assam",
    pins: "781001-781171",
    providers: "900+",
    tagline: "Gateway to Northeast India",
    desc: "Guwahati serves as the hub for Northeast India. Our growing provider network covers tourism, cultural events, and daily needs.",
    areas: ["GS Road", "Zoo Road", "Paltan Bazaar", "Dispur", "Beltola"],
    topServices: ["Travel", "Culture", "Shopping", "Medical Help", "Elder Care"],
    seoContent: "Human on rent in Guwahati — 900+ verified providers. Travel partners for Kaziranga, cultural tours, and support across the Gateway to Northeast."
  },
  {
    slug: "dehradun",
    name: "Dehradun",
    state: "Uttarakhand",
    pins: "248001-249205",
    providers: "800+",
    tagline: "Where Mountains Meet Modern Service",
    desc: "Dehradun's scenic beauty and growing urban population create demand for travel, outdoor, and wellness services.",
    areas: ["Rajpur Road", "Clock Tower", "Mussoorie", "Prem Nagar", "Ballupur"],
    topServices: ["Travel", "Outdoor Events", "Medical Help", "Hanging Out", "Elder Care"],
    seoContent: "Rent a human in Dehradun — 800+ verified providers. Mussoorie trip partners, trekking buddies, and daily support in the Doon Valley."
  },
  {
    slug: "ranchi",
    name: "Ranchi",
    state: "Jharkhand",
    pins: "834001-835325",
    providers: "700+",
    tagline: "City of Waterfalls, City of Service",
    desc: "Ranchi's natural beauty and growing economy drive service demand. Waterfall tours, medical support, and educational services.",
    areas: ["Main Road", "Doranda", "Harmu", "Kanke", "Ratu"],
    topServices: ["Travel", "Medical Help", "Tutoring", "Elder Care", "Shopping"],
    seoContent: "Human on rent in Ranchi — 700+ verified providers. Waterfall tour partners, medical support, and tutoring services across Ranchi."
  },
  {
    slug: "bhubaneswar",
    name: "Bhubaneswar",
    state: "Odisha",
    pins: "751001-752118",
    providers: "1,000+",
    tagline: "Temple City of India",
    desc: "Bhubaneswar's temple heritage and growing IT sector create diverse service needs. Cultural tours and corporate event support.",
    areas: ["Saheed Nagar", "Patia", "Chandrasekharpur", "Nayapalli", "Jaydev Vihar"],
    topServices: ["Culture", "Business Events", "Travel", "Medical Help", "Elder Care"],
    seoContent: "Rent a human in Bhubaneswar — 1,000+ verified providers. Temple tours, IT event support, and cultural experiences in the Temple City."
  },
  {
    slug: "thiruvananthapuram",
    name: "Thiruvananthapuram",
    state: "Kerala",
    pins: "695001-695615",
    providers: "900+",
    tagline: "Capital of God's Own Country",
    desc: "Kerala's capital blends tradition with progress. Tourism, government events, and cultural services drive our provider network here.",
    areas: ["MG Road", "Technopark", "Kazhakootam", "Kowdiar", "Pattom"],
    topServices: ["Travel", "Culture", "Business Events", "Medical Help", "Elder Care"],
    seoContent: "Human on rent in Thiruvananthapuram — 900+ verified providers. Beach tours, IT event partners at Technopark, and cultural experiences in Kerala's capital."
  },
  {
    slug: "mysuru",
    name: "Mysuru",
    state: "Karnataka",
    pins: "570001-571812",
    providers: "800+",
    tagline: "City of Palaces, City of Grace",
    desc: "Mysuru's royal heritage and cultural festivals create unique service demands. Palace tours, Dasara events, and heritage walks.",
    areas: ["Gokulam", "Vijayanagar", "Saraswathipuram", "Kuvempunagar", "JP Nagar"],
    topServices: ["Culture", "Travel", "Shopping", "Dinner", "Elder Care"],
    seoContent: "Rent a human in Mysuru — 800+ verified providers. Palace tour partners, Dasara event support, and cultural experiences in the City of Palaces."
  }
];

export const getCityBySlug = (slug) => {
  return TIER_1_CITIES.find(c => c.slug === slug) || TIER_2_CITIES.find(c => c.slug === slug);
};

export const getAllCities = () => [...TIER_1_CITIES, ...TIER_2_CITIES];
